const ICON_CONTAINER_SIZE = 50;

export default function getSelectStyle({
  backgroundColor,
  borderColor,
  font,
  depth,
  size
}) {
  return {
    inputContainer: {
      base: {
        position: 'relative',
        borderColor: borderColor.base,
        borderWidth: 1,
        borderStyle: 'solid',
        backgroundColor: 'transparent',
        direction: 'ltr',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'unsafe center',
        flexShrink: 0,
        flexGrow: 0,
        flexWrap: 'nowrap',
        padding: '2px 12px 2px 12px',
        height: 36
      },
      hasError: {
        borderColor: borderColor.danger.base
      },
      focus: {
        base: {
          outline: `${size.border.focus}px solid ${borderColor.interactive.focus}`
        },
        hasError: {
          outline: `${size.border.focus}px solid ${borderColor.danger.focus}`
        }
      },
      disabled: {
        borderColor: borderColor.disabled,
        backgroundColor: backgroundColor.disabled
      },
      rtl: {
        direction: 'rtl'
      }
    },

    input: {
      base: {
        appearance: 'none',
        position: 'absolute',
        width: `calc(100% - ${ICON_CONTAINER_SIZE}px)`,
        top: '50%', // needed for ie/chrome-android flexbox bugs
        transform: 'translateY(-50%)',
        flexGrow: 0,
        flexShrink: 1,
        fontFamily: font.base.family,
        fontSize: font.base.size.s,
        color: font.color.base,
        direction: 'ltr',
        border: 'none',
        outline: 'none',
        backgroundColor: 'transparent',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        lineHeight: font.lineHeight.base,
        left: 16,
        '&::-ms-clear': {
          display: 'none'
        } // removes ie "x" clear text button
      },
      rtl: {
        direction: 'rtl',
        right: 16,
        left: 'unset'
      },
      placeholder: {
        color: font.color.soft
      },
      disabled: {
        color: font.color.soft
      }
    },

    iconContainer: {
      base: {
        position: 'absolute',
        top: '50%', // needed for ie/chrome-android flexbox bugs
        transform: 'translateY(-50%)',
        width: ICON_CONTAINER_SIZE,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        flexGrow: 0,
        right: 0,
        left: 'auto'
      },
      rtl: {
        left: 0,
        right: 'auto'
      }
    },

    // use 'color' property only, not true css
    iconColor: {
      base: {
        color: font.color.soft
      },
      disabled: {
        color: font.color.disabled
      }
    },

    magazineContainer: {
      base: {
        maxHeight: 192,
        left: -1,
        right: -1,
        top: '100%',
        boxSizing: 'border-box',
        boxShadow: `
        ${depth.boxShadow.soft.xOffset}
        ${depth.boxShadow.soft.yOffset}
        ${depth.boxShadow.soft.blurRadius}
        ${depth.boxShadow.soft.spreadRadius}
        ${depth.boxShadow.soft.color}
        ${depth.boxShadow.hard.xOffset}
        ${depth.boxShadow.hard.yOffset}
        ${depth.boxShadow.hard.blurRadius}
        ${depth.boxShadow.hard.spreadRadius}
        ${depth.boxShadow.hard.color}
        `
      }
    },

    clearSelection: {
      base: {
        color: font.color.soft,
        fontFamily: font.base.family,
        fontStyle: 'italic'
      },
      focus: {
        color: font.color.interactive.fill
      }
    },

    noMatchMessage: {
      base: {
        color: font.color.disabled,
        fontFamily: font.base.family
      }
    }
  };
}
